/**
 * The visuals setting (ADMIN-204): how often answers draw a table or chart. Remembered in this
 * browser like the composer's model, and sent with every turn so the model gets the matching
 * instructions ("off" leaves the show_visual tool out).
 */

export const VISUAL_LEVELS = [
  { id: "off", name: "Off", description: "Answers are text only" },
  { id: "auto", name: "When useful", description: "A table or chart when it's clearer than prose" },
  { id: "often", name: "Often", description: "Whenever the answer has data that fits one" },
] as const;

export type VisualLevel = (typeof VISUAL_LEVELS)[number]["id"];

const KEY = "kourai-visuals";
const DEFAULT_VISUAL_LEVEL: VisualLevel = "auto";

function parseVisualLevel(value: unknown): VisualLevel {
  return VISUAL_LEVELS.find((level) => level.id === value)?.id ?? DEFAULT_VISUAL_LEVEL;
}

export function getVisualLevel(): VisualLevel {
  try {
    return parseVisualLevel(localStorage.getItem(KEY));
  } catch {
    return DEFAULT_VISUAL_LEVEL;
  }
}

export function saveVisualLevel(level: VisualLevel) {
  try {
    localStorage.setItem(KEY, level);
  } catch {
    // Storage can be unavailable (private mode); the choice still holds for this page.
  }
}
